"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-center sm:justify-between items-center" };
const _hoisted_3 = { class: "text-xl sm:text-2xl mb-4 sm:my-5 sm:ml-5 font-bold uppercase" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_5 = { class: "flex flex-col sm:flex-row bg-white p-4" };
const _hoisted_6 = { class: "flex flex-col items-center xl:flex-row gap-5 w-full" };
const _hoisted_7 = { class: "flex flex-col sm:flex-row gap-5 w-full" };
const _hoisted_8 = { class: "flex flex-col sm:flex-row gap-5 w-full" };
const _hoisted_9 = { class: "flex flex-col w-full" };
const _hoisted_10 = { class: "uppercase font-bold pb-2 text-sm" };
const _hoisted_11 = {
    key: 0,
    class: "marso-icon-right text-green"
};
const _hoisted_12 = {
    key: 1,
    class: "marso-icon-wrong text-red"
};
const _hoisted_13 = { class: "flex flex-col sm:flex-row lg:gap-5 justify-center" };
const _hoisted_14 = ["disabled", "onClick"];
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-refresh" }, null, -1);
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_18 = ["onClick"];
const _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_20 = { class: "flex items-center justify-center" };
const _hoisted_21 = { class: "flex lg:gap-5 justify-center" };
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_24 = { class: "flex items-center justify-center" };
const _hoisted_25 = { class: "flex gap-2 items-center justify-center font-bold" };
const _hoisted_26 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex items-center p-2" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "text-3xl" }, " - "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-right pt-1" })
], -1);
const _hoisted_27 = { class: "flex lg:gap-5 justify-center" };
const _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_29 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const toastStore_1 = require("../../stores/toast/toastStore");
const pricingStore_1 = require("../../stores/pricing/pricingStore");
const vue_router_1 = require("vue-router");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const PricingEnum_1 = require("../../stores/pricing/PricingEnum");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const securityStore_1 = require("../../stores/security/securityStore");
const PricingConflictModal_vue_1 = __importDefault(require("./PricingConflictModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Pricing',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const pricingStore = (0, pricingStore_1.usePricingStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const router = (0, vue_router_1.useRouter)();
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const startDate = (0, vue_3.ref)(null);
        const endDate = (0, vue_3.ref)(null);
        const name = (0, vue_3.ref)(null);
        const brand = (0, vue_3.ref)(null);
        const brandDropdownInputItems = (0, vue_3.ref)([]);
        const status = (0, vue_3.ref)(null);
        const isDeletePricingModalOpen = (0, vue_3.ref)(false);
        const isPricingStatusModalOpen = (0, vue_3.ref)(false);
        const conflictsModalIsOpen = (0, vue_3.ref)(false);
        const pricingConflicts = (0, vue_3.ref)([]);
        const conflictSaveButtonIsActive = (0, vue_3.ref)(false);
        const expandedConflictRow = (0, vue_3.ref)(null);
        const pricingFilters = (0, vue_3.ref)([]);
        const axCategories = [
            "140", "130", "131", "145", "135", "133", "149", "139", "138", "122",
            "120", "110", "160", "150", "170", "123", "127", "445", "440", "420",
            "415", "410", "910", "210", "220", "230", "240", "250", "260", "270",
            "310", "320", "350", "360"
        ];
        const statusOptions = (0, vue_3.ref)([
            new Option_1.default("ALL", (0, i18n_1.trans)("all", "ALL", "pricing"), true),
            new Option_1.default(PricingEnum_1.PricingStatusEnum.ACTIVE, (0, i18n_1.trans)("active", "ACTIVE", "pricing"), false),
            new Option_1.default(PricingEnum_1.PricingStatusEnum.INACTIVE, (0, i18n_1.trans)("inactive", "INACTIVE", "pricing"), false)
        ]);
        const pricingTyreCategoryTranslations = {
            [PricingEnum_1.PricingTyreCategoryEnum.PASSENGER_TYRES]: (0, i18n_1.trans)('passenger_tyres', 'Passenger tyres', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.TRUCK_TYRES]: (0, i18n_1.trans)('truck_tyres', 'Truck tyres', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.AGRICULTURAL_AND_INDUSTRIAL_TYRES]: (0, i18n_1.trans)('agricultural_industrial_tyres', 'Agricultural and industrial tyres', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.FORKLIFT_TYRES]: (0, i18n_1.trans)('forklift_tyres', 'Forklift tyres', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.MOTORCYCLE_TYRES]: (0, i18n_1.trans)('motorcycle_tyres', 'Motorcycle tyres', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.SPARE_WHEELS]: (0, i18n_1.trans)('spare_wheels', 'Spare wheels', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.RIMS]: (0, i18n_1.trans)('rims', 'Rims', 'pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.TUBES_AND_TAPES]: (0, i18n_1.trans)('tubes_and_tapes', 'Tubes and tapes', 'pricing')
        };
        const pricingFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "pricing")) !== null && _a !== void 0 ? _a : "ID",
                value: "id"
            },
            {
                key: "name",
                label: (_b = (0, i18n_1.trans)("name", "Name", "pricing")) !== null && _b !== void 0 ? _b : "Name",
                value: "name",
                sortable: true
            },
            {
                key: "modifiedDate",
                label: (_c = (0, i18n_1.trans)("modified_date", "Modified date", "pricing")) !== null && _c !== void 0 ? _c : "Modified date",
                value: "modifiedDate",
                sortable: true
            },
            {
                key: "type",
                label: (_d = (0, i18n_1.trans)("type", "Type", "pricing")) !== null && _d !== void 0 ? _d : "Type",
                value: "type"
            },
            {
                key: "pricedCategory",
                label: (_e = (0, i18n_1.trans)("priced_category", "Priced category", "pricing")) !== null && _e !== void 0 ? _e : "Priced category",
                value: "pricedCategory"
            },
            {
                key: "status",
                label: (_f = (0, i18n_1.trans)("status", "Status", "pricing")) !== null && _f !== void 0 ? _f : "Status",
                value: "status"
            },
            {
                key: "actions",
                label: ""
            },
        ]);
        const pricingQuery = (0, vue_3.computed)(() => {
            var _a, _b, _c;
            let filters = {};
            if (startDate.value !== null && startDate.value !== "") {
                filters = { ...filters, 'modifiedDate[after]': `${startDate.value}T00:00:00` };
            }
            if (endDate.value !== null && endDate.value !== "") {
                filters = { ...filters, 'modifiedDate[before]': `${endDate.value}T23:59:59` };
            }
            if (name.value !== null && name.value !== "") {
                filters = { ...filters, name: name.value };
            }
            if (brand.value !== null && brand.value !== "") {
                filters = { ...filters, 'customerPricingFilters.brand': brand.value };
            }
            if (status.value !== null && status.value !== "" && status.value !== "ALL") {
                filters = { ...filters, status: status.value };
            }
            if (((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.customer.id) !== null && ((_b = currentUser.value) === null || _b === void 0 ? void 0 : _b.customer.id) !== "") {
                filters = { ...filters, 'customer.id': (_c = currentUser.value) === null || _c === void 0 ? void 0 : _c.customer.id };
            }
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const groupedConflicts = (0, vue_3.computed)(() => {
            const conflictMap = new Map();
            pricingConflicts.value.forEach(conflict => {
                const { customerPricingId, customerPricingName, customerPricingType } = conflict;
                if (!conflictMap.has(customerPricingId)) {
                    conflictMap.set(customerPricingId, {
                        id: customerPricingId,
                        name: customerPricingName,
                        type: customerPricingType,
                        conflicts: []
                    });
                }
                conflictMap.get(customerPricingId).conflicts.push(conflict);
            });
            return Array.from(conflictMap.values());
        });
        (0, vue_3.onMounted)(() => {
            getPricings();
            getBrands();
        });
        (0, vue_3.onUnmounted)(() => {
            brandDropdownInputItems.value = [];
            pricingConflicts.value = [];
            pricingFilters.value = [];
            pricingStore.pricings = [];
        });
        const getBrands = async () => {
            try {
                const result = await productFilterStore.getProductFilters(router, { axCategories, active: 1 });
                brandDropdownInputItems.value = Object.values(result.brands.values);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const getPricings = async () => {
            try {
                await pricingStore.getPricings(router, pricingQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const debouncedGetPricings = (0, debounce_1.default)(() => getPricings(), 300);
        const openDeletePricingModal = (item) => {
            pricingStore.pricingId = item.id;
            pricingStore.pricingName = item.name;
            isDeletePricingModalOpen.value = true;
        };
        const openPricingStatusModal = (item) => {
            pricingStore.pricingId = item.id;
            pricingStore.pricingName = item.name;
            pricingStore.pricingStatus = item.status;
            isPricingStatusModalOpen.value = true;
        };
        const confirmDeletePricing = async () => {
            if (pricingStore.pricingId === null)
                return;
            try {
                await pricingStore.deletePricing(router, pricingStore.pricingId);
                await getPricings();
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricing_deleted_successfully", "Pricing deleted successfully!", "pricing"),
                    type: "success",
                    timer: 5,
                });
                isDeletePricingModalOpen.value = false;
                pricingStore.pricingId = null;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const changePricingStatus = async () => {
            if (pricingStore.pricingId === null)
                return;
            try {
                const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                if (response.message === "Conflicts found") {
                    isPricingStatusModalOpen.value = false;
                    pricingConflicts.value = response.conflicts;
                    conflictsModalIsOpen.value = true;
                }
                else {
                    isPricingStatusModalOpen.value = false;
                    pricingStore.pricingStatus = pricingStore.pricingStatus === PricingEnum_1.PricingStatusEnum.ACTIVE ?
                        PricingEnum_1.PricingStatusEnum.INACTIVE : PricingEnum_1.PricingStatusEnum.ACTIVE;
                    await pricingStore.updatePricing(router, { status: pricingStore.pricingStatus }, pricingStore.pricingId);
                    await getPricings();
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_status_updated_successfully", "Pricing status updated successfully!", "pricing"),
                        type: "success",
                        timer: 5,
                    });
                    pricingStore.pricingId = null;
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const expandConflictRowToggle = (value) => {
            expandedConflictRow.value = value;
        };
        const getPricingFilters = async (pricingId) => {
            if (pricingId) {
                try {
                    const response = await pricingStore.getPricings(router, undefined, pricingId);
                    if (response.customerPricingFilters.length) {
                        pricingFilters.value = response.customerPricingFilters;
                    }
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const deleteConflictedPricingFilter = async (filterId) => {
            if (!pricingStore.pricingId)
                return;
            try {
                await pricingStore.deletePricingFilter(router, filterId);
                await getPricingFilters(pricingStore.pricingId);
                await getPricings();
                const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                if (response.message === "Conflicts found") {
                    pricingConflicts.value = response.conflicts;
                }
                else {
                    pricingConflicts.value = response.conflicts;
                    conflictSaveButtonIsActive.value = true;
                }
                toastStore.addToast({
                    message: (0, i18n_1.trans)("conflicted_pricing_filter_deleted_successfully", "Conflicted pricing filter deleted successfully!", "pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const deleteConflictedPricingFilters = async (id) => {
            const filterIdsToDelete = pricingConflicts.value
                .filter(filter => filter.customerPricingId === id)
                .map(filter => filter.conflictingFilter.id);
            if (filterIdsToDelete.length && pricingStore.pricingId) {
                try {
                    await pricingStore.deletePricingFilters(router, { filterIds: filterIdsToDelete });
                    await getPricingFilters(pricingStore.pricingId);
                    await getPricings();
                    const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                    if (response.message === "Conflicts found") {
                        pricingConflicts.value = response.conflicts;
                    }
                    else {
                        pricingConflicts.value = response.conflicts;
                        conflictSaveButtonIsActive.value = true;
                    }
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_filters_deleted_successfully", "Pricing filters deleted successfully!", "pricing"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const navigateToNewPricing = () => {
            router.push({ name: 'new_pricing' });
        };
        const navigateToEditPricing = (item) => {
            pricingStore.pricingName = item.name;
            pricingStore.pricingStatus = item.status;
            pricingStore.pricingTyreCategoryOption = item.pricedCategory;
            pricingStore.pricingId = item.id;
            pricingStore.axCategories = item.axCategories;
            const routeName = item.type === PricingEnum_1.PricingTypeEnum.FIXED ? 'fixed_pricing' : 'percent_pricing';
            router.push({ name: routeName });
        };
        const saveAndDeactivatePricing = async () => {
            for (const conflict of pricingConflicts.value) {
                try {
                    await pricingStore.updatePricing(router, { status: PricingEnum_1.PricingStatusEnum.INACTIVE }, conflict.customerPricingId);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            if (pricingConflicts.value.length > 1) {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricings_deactivated_successfully", "Pricings deactivated successfully!", "pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            else {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricing_deactivated_successfully", "Pricing deactivated successfully!", "pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            activatePricing();
        };
        const activatePricing = async () => {
            const newPricingStatus = pricingStore.pricingStatus === PricingEnum_1.PricingStatusEnum.ACTIVE
                ? PricingEnum_1.PricingStatusEnum.INACTIVE
                : PricingEnum_1.PricingStatusEnum.ACTIVE;
            if (pricingStore.pricingId !== null) {
                try {
                    await pricingStore.updatePricing(router, { status: newPricingStatus }, pricingStore.pricingId);
                    await getPricings();
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_status_updated_successfully", "Pricing status updated successfully!", "pricing"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            conflictsModalIsOpen.value = false;
            pricingStore.pricingId = null;
        };
        const closePricingConflictModal = () => {
            conflictsModalIsOpen.value = false;
            conflictSaveButtonIsActive.value = false;
        };
        (0, vue_3.watch)(() => pricingQuery.value, () => {
            debouncedGetPricings();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing', 'Pricing', 'pricing')), 1),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4",
                        onClick: navigateToNewPricing
                    }, [
                        _hoisted_4,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("create_new_pricing", "Create new pricing", "pricing")), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                modelValue: startDate.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((startDate).value = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'pricing'),
                                label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'pricing'),
                                type: "date",
                                border: ""
                            }, null, 8, ["modelValue", "placeholder", "label"]),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                modelValue: endDate.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((endDate).value = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'pricing'),
                                label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'pricing'),
                                type: "date",
                                border: ""
                            }, null, 8, ["modelValue", "placeholder", "label"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                modelValue: name.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((name).value = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'pricing'),
                                label: (0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'pricing'),
                                border: ""
                            }, null, 8, ["modelValue", "placeholder", "label"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'pricing')), 1),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    modelValue: brand.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((brand).value = $event)),
                                    class: "h-12 bg-white border-1 border border-gray-dark border-opacity-50",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'pricing'),
                                    items: brandDropdownInputItems.value
                                }, null, 8, ["modelValue", "placeholder", "items"])
                            ])
                        ]),
                        (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                            modelValue: status.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((status).value = $event)),
                            class: "w-full sm:w-1/3 xl:w-1/2",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('status', 'Status', 'pricing'),
                            label: (0, vue_2.unref)(i18n_1.trans)('status', 'Status', 'pricing'),
                            options: statusOptions.value,
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label", "options"])
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: pricingFields.value,
                    "onUpdate:fields": _cache[5] || (_cache[5] = ($event) => ((pricingFields).value = $event)),
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event) => ((page).value = $event)),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[7] || (_cache[7] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[8] || (_cache[8] = ($event) => ((sortDesc).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[9] || (_cache[9] = ($event) => ((itemsPerPage).value = $event)),
                    items: (0, vue_2.unref)(pricingStore).pricings,
                    "is-busy": (0, vue_2.unref)(pricingStore).loading,
                    condensed: "",
                    pagination: "",
                    "total-items": (0, vue_2.unref)(pricingStore).totalPricings,
                    class: "mt-4 text-sm sm:text-base"
                }, {
                    "cell-type": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.type === (0, vue_2.unref)(PricingEnum_1.PricingTypeEnum).PERCENT ?
                            (0, vue_2.unref)(i18n_1.trans)('percent', 'Percent', 'pricing') :
                            (0, vue_2.unref)(i18n_1.trans)('fixed', 'Fixed', 'pricing')), 1)
                    ]),
                    "cell-pricedCategory": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(pricingTyreCategoryTranslations[item.pricedCategory]), 1)
                    ]),
                    "cell-status": (0, vue_2.withCtx)(({ item }) => [
                        (item.status === 'ACTIVE')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_11))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_12))
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary btn-link !text-orange whitespace-nowrap !text-sm sm:!text-base",
                                disabled: !item.customerPricingFilters.length,
                                onClick: ($event) => (openPricingStatusModal(item))
                            }, [
                                _hoisted_15,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("change_status", "Change status", "pricing")), 1)
                            ], 8, _hoisted_14),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link !text-sm sm:!text-base",
                                onClick: ($event) => (navigateToEditPricing(item))
                            }, [
                                _hoisted_17,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "pricing")), 1)
                            ], 8, _hoisted_16),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link !text-sm sm:!text-base",
                                onClick: ($event) => (openDeletePricingModal(item))
                            }, [
                                _hoisted_19,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "pricing")), 1)
                            ], 8, _hoisted_18)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "currentPage", "sortBy", "sortDesc", "itemsPerPage", "items", "is-busy", "total-items"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "width-classes": "w-max-[500px]",
                    title: (0, vue_2.unref)(i18n_1.trans)('confirm_delete_message', 'Are you sure you want to delete this pricing?', 'pricing'),
                    "is-open": isDeletePricingModalOpen.value,
                    closeable: false
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(pricingStore).pricingName), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary btn-link !text-green",
                                onClick: confirmDeletePricing
                            }, [
                                _hoisted_22,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("yes", "Yes", "pricing")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-danger btn-link",
                                onClick: _cache[10] || (_cache[10] = ($event) => (isDeletePricingModalOpen.value = false))
                            }, [
                                _hoisted_23,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cancel", "Cancel", "pricing")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["title", "is-open"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "width-classes": "w-max-[500px]",
                    title: (0, vue_2.unref)(i18n_1.trans)('change_status_message', 'Are you sure you want to change the status?', 'pricing'),
                    "is-open": isPricingStatusModalOpen.value,
                    closeable: false
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(pricingStore).pricingName), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(pricingStore).pricingStatus === (0, vue_2.unref)(PricingEnum_1.PricingStatusEnum).ACTIVE ?
                                (0, vue_2.unref)(i18n_1.trans)('active', 'Active', 'pricing') : (0, vue_2.unref)(i18n_1.trans)('inactive', 'Inactive', 'pricing')), 1),
                            _hoisted_26,
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(pricingStore).pricingStatus === (0, vue_2.unref)(PricingEnum_1.PricingStatusEnum).ACTIVE ?
                                (0, vue_2.unref)(i18n_1.trans)('inactive', 'Inactive', 'pricing') : (0, vue_2.unref)(i18n_1.trans)('active', 'Active', 'pricing')), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary btn-link !text-green",
                                onClick: changePricingStatus
                            }, [
                                _hoisted_28,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("yes", "Yes", "pricing")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-danger btn-link",
                                onClick: _cache[11] || (_cache[11] = ($event) => (isPricingStatusModalOpen.value = false))
                            }, [
                                _hoisted_29,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cancel", "Cancel", "pricing")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["title", "is-open"]),
                (0, vue_2.createVNode)(PricingConflictModal_vue_1.default, {
                    "is-open": conflictsModalIsOpen.value,
                    "conflict-save-button-is-active": conflictSaveButtonIsActive.value,
                    "pricing-conflicts": pricingConflicts.value,
                    "grouped-conflicts": (0, vue_2.unref)(groupedConflicts),
                    "expanded-conflict-row": expandedConflictRow.value,
                    "current-user": (0, vue_2.unref)(currentUser),
                    "onUpdate:isOpen": closePricingConflictModal,
                    "onUpdate:expandedConflictRow": expandConflictRowToggle,
                    onDeleteConflictedPricingFilter: deleteConflictedPricingFilter,
                    onDeleteConflictedPricingFilters: deleteConflictedPricingFilters,
                    onSaveAndDeactivatePricing: saveAndDeactivatePricing,
                    onActivatePricing: activatePricing
                }, null, 8, ["is-open", "conflict-save-button-is-active", "pricing-conflicts", "grouped-conflicts", "expanded-conflict-row", "current-user"])
            ]));
        };
    }
});
